export const NON_FINANCIAL_COMMUNICATION_EVENT_TYPES = [
  'ORDER_STATUS_CHANGED',
  'WZ_CREATED',
  'WZ_STATUS_CHANGED',
  'TRANSPORT_UPDATED',
  'ORDER_CONFIRMED_STOCK',
  // Decision 2026-10-04: quantities only, no prices.
  'ORDER_STATUS_SHORTAGE',
  'ORDER_CONFIRMED_STOCK_CUSTOMER',
] as const;

export const FINANCIAL_COMMUNICATION_EVENT_TYPES = [
  'ORDER_CREATED',
  'COST_ADDED',
  'COST_MODIFIED',
  'COST_DELETED',
  'LOW_MARGIN_ALERT',
] as const;

export const getCommunicationEventTypeOptions = (canViewFinancialEvents: boolean): string[] => (
  canViewFinancialEvents
    ? [...NON_FINANCIAL_COMMUNICATION_EVENT_TYPES, ...FINANCIAL_COMMUNICATION_EVENT_TYPES]
    : [...NON_FINANCIAL_COMMUNICATION_EVENT_TYPES]
);
